import { BepaalStatuutText } from "@cms/types";
import htmlToMarkdown from "@helpers/htmlToMarkdown";
import selectText from "@helpers/selectText";
import axios from "axios";
import Head from "next/head";
import { useRouter } from "next/router";
import React from "react";
import BepaalStatuut from "../components/bepaal-statuut/BepaalStatuut";
import fallbackText from "../public/cms/bepaal-statuut.json";

export const TextContext = React.createContext<undefined | BepaalStatuutText>(undefined);

export default function bepaalStatuut(props: { cmsData: any }) {
  const router = useRouter();
  const language = router.locale;
  const text = selectText(props.cmsData, language as "nl" | "fr" | "en") as BepaalStatuutText;
  return (
    <TextContext.Provider value={text}>
      <Head>
        <title>{text.welcome_title}</title>
      </Head>
      <BepaalStatuut />
    </TextContext.Provider>
  );
}

export async function getStaticProps() {
  try {
    // replace this with the Dropsolid endpoint
    const cmsUrl = "http://labelcms.acerta.be/node/6?_format=json";
    const req = await axios.get(cmsUrl);
    console.log("successfully fetched content from drupal");
    const data = req.data.field_acerta_translations_field;
    const markdownData = htmlToMarkdown(data);
    return { props: { cmsData: markdownData } };
  } catch (e) {
    console.error("could not fetch text from the cms, using the fallback option");
    // console.error(e)
    return { props: { cmsData: fallbackText } };
  }
}
